/* globals $ */
import Component from './component';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {
  text: '',
  wordsPerMinute: 200,
};

export default class ReadTime extends Component {

  constructor($context, options) {
    super(defaults, options);

    this.$context = $context;
    this.wordsCount = 0;
    this.readTime = 0;

    this.init();
  }

  init() {
    if (typeof this.settings.text === 'string' && this.settings.text.length) {
      this.wordsCount = ReadTime.countWords(this.settings.text);
      this.readTime = Math.ceil(this.wordsCount / this.settings.wordsPerMinute) || 1;
    }

    this.updateTimer();
  }

  updateTimer() {
    this.$context.text(`${this.readTime} min`);
  }

  static countWords(s) {
    s = s.replace(/(^\s*)|(\s*$)/gi, ''); // exclude  start and end white-space
    s = s.replace(/[ ]{2,}/gi, ' '); // 2 or more space to 1
    s = s.replace(/\n /, '\n'); // exclude newline with a start spacing

    return s.split(' ').filter(str => str !== '').length;

    // return s.split(' ').filter(String).length; - this can also be used
  }

  static initialize($context = $(document.body), options = {}) {
    return super.initialize('.js-read-time', ReadTime, 'ReadTime', $context, options);
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/read-time.js